import { ReactElement } from 'react'
import { ProjectApplicationAssessmentDetailsIndex } from 'src/screens/shared/application/assessment/details/ProjectApplicationAssessmentDetailsIndex'

export const PfPgvAssessmentDetailsIndexPage = (): ReactElement => {
  return <ProjectApplicationAssessmentDetailsIndex baseUrl="/pf-pgv" />
}
